export default __webpack_public_path__ + "static/media/logo.83ed3728.svg";